import { Navigate, useLocation } from 'react-router'
import { useAuth } from '../../hooks/useAuth'
import PageLoader from '../common/PageLoader'

type Props = {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: Props) {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <PageLoader />
  if (!user) {
    const returnTo = `${location.pathname}${location.search}`
    return <Navigate to={`/signin?returnTo=${encodeURIComponent(returnTo)}`} replace />
  }
  return <>{children}</>
}
